import { ConnectBlockEmail } from 'components/connectBlocks/ConnectBlockEmail';
import { ConnectBlockSubscribe } from 'components/connectBlocks/ConnectBlockSubscribe';
import { ConnectBlockTagline } from 'components/connectBlocks/ConnectBlockTagline';
import { Link } from 'components/link/Link';
import { GlobalDataType } from 'utils/parsers';

import style from './MainFooter.module.scss';

export const MainFooter = (props: GlobalDataType): JSX.Element => {
  const {contact, social} = props;

  return (
    <div className={style.footer}>
      <div className={style.tagLine}>
        <ConnectBlockTagline intro={contact.blurbHtml} />
      </div>
      {contact.offices && contact.offices.length ? (
        contact.offices.map((office, idx) => {
          return (
            <div key={idx} className={`${style.office} ${idx % 2 === 0 ? 'even' : 'odd'}`}>
              <p>{ office.name }</p>
              {office.phone && <p><a href={office.phone_url}>{office.phone}</a></p>}
              {office.address && <div dangerouslySetInnerHTML={{ __html: office.address }} />}
            </div>
          )
        })
      ) : (
        <>
          {contact.emailHtml && (
            <div className={`${style.email}`}>
              <ConnectBlockEmail html={contact.emailHtml} />
            </div>
          )}
          {contact.addressHtml && (
            <div className={`${style.address}`}>
              <ConnectBlockEmail html={contact.addressHtml} />
            </div>
          )}
        </>
      )}
      <div className={`${style.subscribe}`}>
        <ConnectBlockSubscribe
          email={contact.emailAddress}
          facebookLink={social.facebook}
          instagramLink={social.instagram}
          linkedinLink={social.linkedin}
          pinterestLink={social.pintrest}
        />
      </div>
      <div className={style.copyright}>
          Co-Partnership. © {new Date().getFullYear()} All Rights Reserved.
          <br />
          <Link href="/privacy">
            <a className={style.copyrightLink}>Privacy Policy</a>
          </Link>
          .{' '}
          <Link href="/terms">
            <a className={style.copyrightLink}>Terms of Use</a>
          </Link>
        </div>
    </div>
  );
};
